<style>
  ::ng-deep .green-background {
    background-color: #389638 !important;
  }
</style>


<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Inventario Comercial <i class="fas fa-solid fa-download" (click)="exportToXLSX()"></i>
        </h3>
      </div>
      <!-- /.card-header -->
      <div class="card-body">
        <div class="row">
          <div class="col-3">
            <label>Lista de precio</label>
            <select class="form-control" [(ngModel)]="listaPrecio" (change)="cambiaPrecio();">
              <option *ngFor="let item of OPLN" [ngValue]="item.ListNum">{{item.ListName}}</option>
            </select>
          </div>
          <div class="col-3">
            <label>Categoria</label>
            <select class="form-control" [(ngModel)]="categoriaSeleccionada" (change)="filtro()">
              <option value="">Seleccione una categoria</option>
              <option *ngFor="let item of listaCategorias" [ngValue]="item">{{item}}</option>
            </select>
          </div>
          <div class="col-3">
            <label>Familia</label>
            <select class="form-control" [(ngModel)]="familiaSeleccionada" (change)="filtro()">
              <option value="">Seleccione una familia</option>
              <option *ngFor="let item of listaFamilia" [ngValue]="item">{{item}}</option>
            </select>
          </div>
          <div class="col-3">
            <label>Sub-Familia</label>
            <select class="form-control" [(ngModel)]="subFamiliaSeleccionada" (change)="filtro()">
              <option value="">Seleccione una sub-familia</option>
              <option *ngFor="let item of listaSubFamilia" [ngValue]="item">{{item}}</option>
            </select>
          </div>
        </div>
        <div class="row align-items-end">
          <div class="col-6 col-md-3 mb-2">
            <button type="button" class="btn btn-warning w-100" (click)="limpiar();">Limpiar</button>
          </div>
          <div class="col-6 col-md-3 mb-2">
            <button type="button" class="btn btn-primary w-100" (click)="openScanner()">
              <i class="fa fa-barcode"></i> Escanear código
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <ngx-table #table [configuration]="configuration" [data]="data" [columns]="columns"></ngx-table>

            <ng-template #frmItemCode let-row let-rowIndex="rowIndex">

              <div [id]="'item-' + row.ItemCode" [class.bg-warning]="row.ItemCode === highlightItemCode" style="display: flex;">

                <div class="estrella" style="display: flex;justify-content: center;align-items: center;height: 100%;padding: 10px;" *ngIf="row.tieneDetalle">
                  <i class="fa-solid fa-star" style="color: #ffdc00;cursor: pointer;" (click)="abrirListaItem(row)"></i>
                </div>
  
                <button class="btn btn-primary" (click)="AbrirDetalleItem(row)">{{row.ItemCode}}</button>
              </div>
  
            </ng-template>

            <ng-template #frmDisponibleVenta let-row let-rowIndex="rowIndex">

              {{row.OnHand - row.IsCommited}}
  
            </ng-template>

            <ng-template #frmSTOCK_PEDIDO_INTERNO let-row let-rowIndex="rowIndex">

              <div style="display: flex;">
  
                <button class="btn btn-primary" (click)="AbrirDetalleItemPedidoInterno(row)">{{row.STOCK_PEDIDO_INTERNO}}</button>
              </div>
  
            </ng-template>

            <ng-template #frmPrice let-row let-rowIndex="rowIndex">
              <!-- <div>{{row.Price | iNDCLP}}</div> -->
              <!-- <div *ngIf="row.Currency != 'CLP'">{{row.Price | currency: row.Currency}}</div> -->
              <div *ngIf="row.Currency != 'CLP'">{{row.Price | iNDCLP}}</div>
              <div *ngIf="row.Currency == 'CLP'">{{row.Price | iNDCLP}}</div>
            </ng-template>

          </div>
        </div>


      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
  </div>
  <!-- /.col -->
</div>

<!-- Scanner overlay -->
<div class="scanner-backdrop" *ngIf="showScanner" (click)="closeScanner()"></div>
<div class="scanner-modal" *ngIf="showScanner" role="dialog" aria-modal="true" aria-label="Escanear código" (click)="$event.stopPropagation()">
  <div class="scanner-header">
    <div class="title">
      <i class="fas fa-barcode"></i>
      <span>Escanear código de barras</span>
    </div>
    <button class="icon-btn" (click)="closeScanner()" aria-label="Cerrar">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="scanner-body">
    <div class="video-wrap">
      <video #video autoplay playsinline muted></video>
      <div class="scan-frame"><span class="scan-line"></span></div>
      <div class="scanner-hint" *ngIf="scannerError">
        <i class="fas fa-info-circle"></i> {{ scannerError }}
      </div>
    </div>

    <div class="scanner-toolbar">
      <div class="left">
        <select class="form-select form-select-sm" [value]="selectedDeviceId || ''" (change)="onCameraChange($event)">
          <option [value]="''">Cámara predeterminada</option>
          <option *ngFor="let d of devices; let i = index" [value]="d.deviceId">
            {{ d.label || ('Cámara ' + (i + 1)) }}
          </option>
        </select>
      </div>
      <div class="right">
        <button class="icon-btn" [class.active]="torchOn" (click)="toggleTorch()" [disabled]="!torchSupported" title="Linterna">
          <i class="fas fa-bolt"></i>
        </button>
        <button class="icon-btn" (click)="flipCamera()" [disabled]="!canFlip" title="Cambiar cámara">
          <i class="fas fa-sync-alt"></i>
        </button>
      </div>
    </div>

    <div class="scanner-fallback">
      <label class="form-label">¿Sin escáner? Ingresa el código:</label>
      <div class="input-group input-group-sm">
        <input class="form-control" [(ngModel)]="manualCode" placeholder="ItemCode o código leído" />
        <button class="btn btn-primary" (click)="applyManualCode()">Buscar</button>
      </div>
    </div>
  </div>
</div>